import { Component } from '@angular/core';
import { NavController, AlertController ,NavParams,ToastController, LoadingController} from 'ionic-angular';
import { Platform } from 'ionic-angular';
import {Storage} from '@ionic/storage';
import {ServiceProvider} from '../../providers/service/service';
import { ViewController } from 'ionic-angular';
import {EnquiryPage} from "../enquiry/enquiry";



@Component({
  selector: 'page-enquirystatus',
  templateUrl: 'enquirystatus.html',
})
export class EnquirystatusPage {
  call_response:any;
  admission_response:any;
  meeting_response:any;
  Comment:any;
  Date:any;
  eqId:any;
  admissionres:any;
  callingres:any;
  Meeting:any;
  FCallHistoryId:any;
  date:any;
  index:any;
  parentsobjdata:any;
  selectedobj:any[] =[];
  indx:any;
  Time:any;
  display_form='none';

  constructor(public navCtrl: NavController, public service: ServiceProvider, platform: Platform, public storage: Storage,public alertCtrl: AlertController,public navParams: NavParams,public toastCtrl: ToastController,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController){

    platform.ready().then(() => {

      this.eqId=this.navParams.get('eqId');
      this.FCallHistoryId=this.navParams.get('FCallHistoryId');
      console.log('FCallHistoryId',this.FCallHistoryId);
      this.date=this.navParams.get('date');

      this.load_call_response();
      this.load_admission_response();
      this.load_meeting_status();
      this.load_parents_objection();
    })

  }

  selectedDate(date)
  {
    console.log(date);

  }


  goBack(){
    this.navCtrl.pop();
  }



  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.load_call_response();
    this.load_admission_response();
    this.load_meeting_status();
    this.load_parents_objection();
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  load_call_response() {
    this.service.httpcall("web_service/get_calling_response?").subscribe(data => {
      console.log(data);
     // console.log(data.length);
      this.call_response = data;
    })
  }

  selected_call_response(res){
    console.log(res);
    if(res['IsPositiveResponse']==1){
      this.display_form='block';
    }else {
      this.display_form='none';
    }
  }

  load_parents_objection() {
    this.service.httpcall("web_service/get_parents_objection?").subscribe(data => {
      console.log(data);
    //  console.log(data.length);
      this.parentsobjdata = data;
    })
  }

  load_admission_response() {
    this.service.httpcall("web_service/get_admission_response?").subscribe(data => {
      console.log(data);
    //  console.log(data.length);
      this.admission_response = data;
    })
  }

  load_meeting_status() {
    this.service.httpcall("web_service/get_management_meeeting_response?").subscribe(data => {
      console.log(data);
    //  console.log(data.length);
      this.meeting_response = data;
    })
  }

  parentOjData(idx,FPobjectionId, obj) {
    console.log("params",idx,FPobjectionId, obj);

    if(obj.checked) {
      this.selectedobj.push(FPobjectionId);
    } else {

      this.indx =this.selectedobj.indexOf(FPobjectionId);
      this.selectedobj.splice(this.indx,1);

    }
    console.log("this.selectedobj",this.selectedobj);

  }



  saveEqStatus() {

    if(this.callingres == undefined){
      let toast = this.toastCtrl.create({
        message: 'Please Select Calling Response',
        duration: 5000,
        position: 'bottom'
      });
      toast.present();
    }else {

    let postdata = {
      Comment: this.Comment,
      Date: this.Date,
      Time: this.Time,
      AdmissionresId: this.admissionres,
      FCallresId: this.callingres.Id,
      FMeetingId: this.Meeting,
      selectedobj:this.selectedobj,
      FCallHistoryId:this.FCallHistoryId

    };
      let loading = this.loadingCtrl.create({
        content: 'Loading'
      });
      loading.present();
      setTimeout(() => {
        loading.dismiss();
      }, 5000);
    console.log('postdata', postdata);
    console.log('this.FCallHistoryId',this.FCallHistoryId);
      this.service.httppostcall("web_service/add_status", postdata).subscribe((data:any) => {

        if(data['response']=='success') {
          loading.dismiss();
          let toast = this.toastCtrl.create({
            message: data['success_message'],
            duration: 5000,
            position: 'bottom'
          });
          toast.present();
          //this.navCtrl.setRoot(EnquiryPage);
          this.navParams.get("parentPage").refresh();
          this.viewCtrl.dismiss();
        }else{
          let toast = this.toastCtrl.create({
            message: data['error_description'],
            duration: 5000,
            position: 'bottom'
          });
          toast.present();
        }
      })
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EnquirystatusPage');
  }

}




// WEBPACK FOOTER //
// ./src/pages/enquirystatus/enquirystatus.ts